import NetworkOverviewPage from '@/views/network/NetworkOverviewPage.vue';
import NetworkVpnPage from '@/views/network/NetworkVpnPage.vue';
import NetworkEthernetPage from '@/views/network/NetworkEthernetPage.vue';
import NetworkAdvancedPage from '@/views/network/NetworkAdvancedPage.vue';

export default class NetworkRoutes {
  public static Routes = [
    {
      path: 'overview',
      name: 'network-overview',
      component: NetworkOverviewPage,
      meta: {
        label: 'Overview',
      },
    },
    {
      path: 'ethernet',
      name: 'network-ethernet',
      component: NetworkEthernetPage,
      meta: {
        label: 'Ethernet',
      },
    },
    {
      path: 'vpn',
      name: 'network-vpn',
      component: NetworkVpnPage,
      meta: {
        label: 'VPN',
        beta: true,
      },
    },
    {
      path: 'advanced',
      name: 'network-advanced',
      component: NetworkAdvancedPage,
      meta: {
        label: 'Advanced',
      },
    },
  ];
}
